import React from "react";
import { landingAssets } from "config/landing";
import { ReactComponent as PrimaryShape } from "../../assets/shape-primary.svg";
import { ReactComponent as WhiteShape } from "../../assets/shape-white.svg";
import { ReactComponent as BlackShape } from "../../assets/shape-black.svg";

const heroBackground = landingAssets.heroBackground;
const heroRightImage = landingAssets.heroRightImage;
const heroPrimaryShapeText = landingAssets.metadata.heroPrimaryShapeText;

export const Hero: React.FC = () => (
  <section className="relative mx-3 my-3 flex flex-row items-center overflow-hidden rounded-xl lg:rounded-[30px] text-white sm:my-6 md:mx-5 lg:mx-10 2xl:mx-20 min-h-[200px] sm:min-h-[220px] md:min-h-[240px] lg:min-h-[320px] xl:min-h-[380px] 2xl:min-h-[600px]">
    <div
      className="absolute inset-0 -z-10 rounded-xl lg:rounded-[30px]"
      style={{
        backgroundImage: `url(${heroBackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      aria-hidden="true"
    />

    <div className="relative z-20 flex w-full flex-col justify-center gap-3 px-3 lg:px-6 lg:gap-6 2xl:px-20">
      <div>
        {/* Brand label */}
        <div className="relative w-fit h-7 sm:h-9 lg:h-16 xl:h-20 2xl:h-24 max-w-40 sm:max-w-44 md:max-w-52 lg:max-w-96 xl:max-w-lg">
          <PrimaryShape
            className="h-full w-full text-primary"
            aria-hidden="true"
          />
          <span className="absolute inset-0 h-auto flex w-full items-center justify-start whitespace-nowrap px-4 text-sm font-extrabold uppercase text-white sm:px-5 sm:text-base md:px-6 md:text-lg lg:px-10 lg:text-3xl xl:text-4xl 2xl:px-12 2xl:text-5xl">
            {heroPrimaryShapeText}
          </span>
        </div>

        {/* Easy Integration */}
        <div className="relative h-7 w-fit sm:h-8 md:h-9 lg:h-12 xl:h-14 2xl:h-16 max-w-32 sm:max-w-40 md:max-w-48 lg:max-w-80 xl:max-w-md">
          <BlackShape className="h-full w-full" aria-hidden="true" />
          <span className="absolute inset-0 h-auto flex w-full items-center justify-start whitespace-nowrap px-4 text-[10px] font-extrabold sm:px-5 sm:text-xs md:px-6 md:text-sm lg:px-8 lg:text-lg xl:text-xl 2xl:px-10 2xl:text-2xl">
            Easy Integration
          </span>
        </div>
      </div>

      {/* Description */}
      <div className="relative h-14 w-full sm:h-8 md:h-9 lg:h-12 xl:h-14 2xl:h-16 max-w-[80%] sm:max-w-[70%]">
        <WhiteShape className="h-full w-full" aria-hidden="true" />
        <span className="absolute text-black inset-0 h-auto flex w-full items-center justify-start break-words px-4 text-[10px] font-bold sm:px-5 md:px-6 lg:px-8 lg:text-sm 2xl:px-10 2xl:text-2xl">
          Football, basketball, tennis, volleyball, ice hockey, and baseball.
          Watch the games live. Quickly and easily adapt all trackers as
          iFrames.
        </span>
      </div>
    </div>

    {/* Right player image */}
    <div className="pointer-events-none absolute bottom-0 right-0 z-10 flex h-full w-1/2 items-end justify-end pr-3 sm:w-2/5 sm:pr-4 lg:w-1/3 lg:pr-6 2xl:w-2/5 2xl:pr-20">
      <div
        className="h-full w-full max-h-full bg-contain bg-bottom bg-no-repeat"
        style={{ backgroundImage: `url(${heroRightImage})` }}
        aria-hidden="true"
      />
    </div>
  </section>
);
